module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Deviation Status"},"no":{"title":"Avviksstatus"}}')
  delete Component.options._Ctor
}
